import { put, select, takeLatest, call, all } from 'redux-saga/effects';
import _ from 'lodash';
import { getCardViewConfig } from '../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import {
  CARD_VIEW_CONTENT_LOADED,
  DETAILS_VIEW_CONTENT_LOADED,
  fetchMyPrivilegesAuthTokenSuccess,
  fetchMyPrivilegesAuthTokenFailure,
  CARD_VIEW_MOUNTED,
  DETAILS_VIEW_MOUNTED,
} from '../actions/myPrivilegesAction';
import {
  fetchMyPrivilegesAuthToken,
  CTA_BUTTON_POST_TRIGGER,
  CTA_BUTTON_ONCLICK,
} from '../../../modules/myPrivileges/actions/myPrivilegesAction';
import {
  getDisclaimerInfoApiApi,
  getAxaGoalCustomerState,
} from '../selectors/vhisSelectors';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  FETCH_AXA_GOAL_CUSTOMER_STATE,
  FETCH_AXA_GOAL_CUSTOMER_STATE_SUCCESS,
} from '../actions/vhisAction';
import { SHOW_AXA_GOAL_DASHBOARD } from '../../emma-common/actions';
import config from '../package.json';

function* cardViewMounted(): any {
  const config = yield select(getCardViewConfig, 'emma-vhis');
  yield put({ type: CARD_VIEW_CONTENT_LOADED, config });
}

function* detailsViewMounted(action: any): any {
  const config = yield select(getCardViewConfig, 'emma-vhis');
  yield all([put({ type: FETCH_AXA_GOAL_CUSTOMER_STATE })]);
  yield put({
    type: DETAILS_VIEW_CONTENT_LOADED,
    config,
    isLocked: action.payload.isLocked,
  });
}

function* fetchMyPrivilegesAuthTokenConfig(action: any): any {
  const { MyPrivilegesAuthToken } = action.config;
  const { isLocked } = action;
  if (MyPrivilegesAuthToken && MyPrivilegesAuthToken.url && !isLocked) {
    yield put(
      fetchMyPrivilegesAuthToken(
        MyPrivilegesAuthToken.url,
        fetchMyPrivilegesAuthTokenSuccess,
        fetchMyPrivilegesAuthTokenFailure,
      ),
    );
  }
}

function* fetchAXAGoalCustomerState(action: any): any {
  const axaGoalCustomerState = yield select(getAxaGoalCustomerState);
  if (!axaGoalCustomerState) {
    const disclaimerUrl = yield select(getDisclaimerInfoApiApi);
    const res = yield call(myAxaFetchWithToken, disclaimerUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    const data = yield res.json();
    if (!data) throw new Error();
    const customerState =
      (data && data.length > 0 && data[0].custValue) || '{}';
    const custValue = JSON.parse(customerState);
    yield put({
      type: FETCH_AXA_GOAL_CUSTOMER_STATE_SUCCESS,
      payload: { custValue },
    });
  }
}

function* onClickCTAButton(action: any): any {
  const { cardViewId } = action.payload;
  if (cardViewId === config.id) {
    yield put({ type: SHOW_AXA_GOAL_DASHBOARD });
  } else {
    yield put({ type: CTA_BUTTON_POST_TRIGGER });
  }
}

function* myPrivilegesSaga(): any {
  yield takeLatest(FETCH_AXA_GOAL_CUSTOMER_STATE, fetchAXAGoalCustomerState);
  yield takeLatest(CARD_VIEW_MOUNTED, cardViewMounted);
  yield takeLatest(DETAILS_VIEW_MOUNTED, detailsViewMounted);
  yield takeLatest(
    DETAILS_VIEW_CONTENT_LOADED,
    fetchMyPrivilegesAuthTokenConfig,
  );
  yield takeLatest(CTA_BUTTON_ONCLICK, onClickCTAButton);
}

export default myPrivilegesSaga;
